import { IsString, Matches, MaxLength, MinLength } from 'class-validator';

export class RegisterCredentialsDto {
  // Gleiche Regeln wie beim Anlegen in der Benutzerverwaltung (SaveUserDto), Länge der DB-Spalte
  @IsString()
  @MinLength(4)
  @MaxLength(255)
  username!: string;

  @IsString()
  @MinLength(6)
  @MaxLength(20)
  @Matches(/((?=.*\d)|(?=.*\w+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/, {
    message:
      'Das gewählte Passwort ist zu schwach. Es muss mindestens einen Groß- und einen Kleinbuchstaben enthalten sowie zwischen 6 und 20 Zeichen lang sein.',
  })
  password!: string;
}
